<template lang="pug">
div
  app-modal-assinar-titulo(
    v-if="showModalAssinatura",
    :idsProcessos="idsProcessosAssinatura",
    @closeModal="closeModalAssinatura"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :numeroProtocolo="numeroProtocolo"
    :tipo="tipoProcesso"
  )
  app-modal-avocar(
    v-if="showModalAvocar && idsProcessos.length > 0",
    @closeModal="showModalAvocar = false",
    :idsProcessos="idsProcessos"
  )
  app-modal-solicitar-retificacao(
    v-if="solicitarRetificacao",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :setor="setorSelecionado",
    @closeModal="solicitarRetificacao = false"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL",
    @refresh="refresh"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="showButtonOrdemServico",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="false",
    :filtro="filtro"
    :infoPrazos="showInfoVencimento() && infoPrazos"
    @atualizarFiltro="atualizarFiltro"
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise"
    @executar="executar",
    @selected="CRIAR_ORDEM_SERVICO",
    @selectItem="SELECIONA_PROCESSO"
    @regerar="REGERAR_PROCESSOS"
    :showButtonRegerar="showButtonRegerar()"
  )
  span.padding-left(v-if="showButtonOrdemServico") {{ 'Processos Selecionados: ' + idsProcessos.length }}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import AppListagem from '@/components/AppListagem.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalAvocar from '@/screens/analise/components/modal/AppModalAvocar'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalAssinarTitulo from '@/screens/analise/components/AppModalAssinarTitulo'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
import AppModalRegerar from '@/screens/analise/components/modal/AppModalRegerar'
const { filtro, showFiltroTipoMultiplo, isGcgCgir } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default
const { setores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'ordem-servico') {
      this.setProcessoSelecionados({ processos: [], map: true })
    }
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalAvocar,
    ModalTrocarResponsavel,
    AppModalAssinarTitulo,
    AppModalSolicitarRetificacao,
    AppModalRegerar
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_ENTRADA_UC'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GRF', 'GAM', 'GEA', 'DJ', 'CDI', 'CPAV', 'GP', 'GIT' ],
      processosSelecionados: [],
      showModalResponsavel: false,
      disabledAnalisar: false,
      showModalVisualizarProcesso: false,
      solicitarRetificacao: false,
      showModalAssinatura: false,
      showModalAvocar: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      numeroProtocolo: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_ENTRADA || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_ENTRADA || [],
        filtroReceita: filtro?.filtroReceita?.CAIXA_ENTRADA || [],
        filtroMunicipio: filtro?.filtroMunicipio?.CAIXA_ENTRADA || [],
        filtroOrdemServico: filtro?.filtroOrdemServico?.CAIXA_ENTRADA || [],
        filtroFuncao: filtro?.filtroFuncao?.CAIXA_ENTRADA || [],
        filtroDataVencimento: filtro?.filtroDataVencimento?.CAIXA_ENTRADA || [],
        filtroRua: filtro?.filtroRua?.CAIXA_ENTRADA || [],
        filtroBairro: filtro?.filtroBairro?.CAIXA_ENTRADA || [],
        filtroRemessa: filtro?.filtroRemessa?.CAIXA_ENTRADA || [],
        filtroQuadra: filtro?.filtroQuadra?.CAIXA_ENTRADA || [],
        filtroClausulaResolutiva: filtro?.filtroClausulaResolutiva?.CAIXA_ENTRADA || [],
        filtroVistoriador: filtro?.filtroVistoriador?.CAIXA_ENTRADA || [],
        filtroPerfil: filtro?.filtroPerfil?.CAIXA_ENTRADA || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => this.showButtonRegerar(), ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'Número do CNUC', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome da UC', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => true },
        { id: 3, titulo: 'Esfera', propriedade: 'esfera', ordem: 4, acoes: [], exibir: () => true },
        { id: 3, titulo: 'Categoria de manejo', propriedade: 'grupoDeManejo', ordem: 4, acoes: [], exibir: () => true },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 7, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => true },
        {
          id: 11, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Analisar Processo', icone: 'fa-file', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: this.showAnalisarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showModalVisualizarProcessoUc },
            { id: 3, nome: 'Vincular Responsável', icone: 'fa-user-plus', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showVincularAnalista },
            { id: 4, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showTrocarResponsavel }
          ]
        }
      ],
      usuario: null,
      filtroRapido: null,
      showFiltroTipoMultiplo,
      isPa: process.env.ESTADO === 'pa'
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  beforeDestroy () {
    this.ordemServicoClear()
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    ...mapState({
      listaProcessosAuxiliar: state => state.ordemServico.listaProcessosAuxiliar
    }),
    showButtonOrdemServico () {
      return false
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    }
  },

  methods: {

    ...mapActions({
      ordemServicoClear: 'ordemServico/clear',
      setListaProcessoAuxiliar: 'ordemServico/setListaProcessoAuxiliar',
      retornarSetor: 'processo/retornarSetor',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      getPvtnAtivo: 'vtn/getPvtnAtivo',
      checkAnaliseManual: 'processo/checkAnaliseManual',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      iniciarValidaoManual: 'processo/iniciarValidaoManual',
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      tramitarComAcao: 'processo/tramitarComAcao',
      regerar: 'filaAnaliseAutomatizada/regerar',
      retirarProcessoDaFila: 'filaAnaliseAutomatizada/retirarProcessoDaFila'
    }),

    showButtonRegerar () {
      return isGcgCgir(this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo)
    },

    showInfoVencimento () {
      return !!this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    async EMITIR_OFICIO (_this, {item}) {
      await _this.executarTramitacaoByPerfil(item.id)
      this.$router.push({
        name: 'oficio',
        query: {
          idProcesso: item.id
        }
      })
    },
    async CONTINUAR_EMISSAO_OFICIO (_this, { item }) {
      this.$router.push({
        name: 'oficio',
        query: {
          idProcesso: item.id
        },
        params: {
          isEdicao: true
        }
      })
    },
    SELECIONA_PROCESSO (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        this.idsProcessos.push(item.id)
      } else {
        this.idsProcessos.splice(this.idsProcessos.indexOf(item.id), 1)
      }
      this.setListaProcessoAuxiliar(item)
      this.setProcessoSelecionados({ processos: this.listaProcessosAuxiliar, map: true }) //eslint-disable-line
    },
    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()

      this.exportarCsvAnalise(this.filtro)
    },
    CRIAR_ORDEM_SERVICO () {
      if (this.idsProcessos.length > 0) {
        this.$router.push({
          name: 'ordem-servico'
        })
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Para vincular uma equipe, selecione ao menos um processo.')
      }
    },
    ANALISAR_PROCESSO: async (_this, { item }) => {
      if (_this.isPa && item?.analiseAutomatizadaPendente && setores.GCG_CGIR.includes(item.setor)) {
        _this.confirmBox(_this.$messages.AVISO_ANALISE_AUTOMATIZADA_INCOMPLETA, _this.$messages.TITULO_WARNING,
          async () => {
            await _this.checkAnaliseManual(item.id)
            await _this.executarTramitacao(item.id)
            await _this.retirarProcessoDaFila(item.id)
            _this.$router.push({
              name: 'analise/analisar',
              params: {
                idProcesso: item.id,
                acaoCaixa: 'ANALISE',
                analiseManual: true
              }
            })
          },
          () => { }
        )
      } else if (!_this.disabledAnalisar) {
        _this.disabledAnalisar = true
        try {
          await _this.executarTramitacao(item.id)
          _this.$router.push({
            name: 'analise/analisar',
            params: {
              idProcesso: item.id,
              acaoCaixa: 'ANALISE'
            }
          })
          _this.disabledAnalisar = false
        } catch (e) {
          _this.disabledAnalisar = false
          throw e
        }
      }
    },
    EMITIR_CERTIDAO_AREA: async (_this, { item }) => {
      if (!_this.disabledAnalisar) {
        _this.disabledAnalisar = true
        try {
          await _this.executarTramitacao(item.id)
          _this.$router.push({
            name: 'EMITIR_CERITDAO_AREA',
            params: {
              idProcesso: item.id,
              acaoCaixa: 'ANALISE'
            }
          })
          _this.disabledAnalisar = false
        } catch (e) {
          _this.disabledAnalisar = false
          throw e
        }
      }
    },
    ANALISAR_PROCESSO_SEM_TRAMITACAO: async (_this, { item }) => {
      if (!this.disabledAnalisar) {
        this.disabledAnalisar = true
        _this.$router.push({
          name: 'analise/analisar',
          params: {
            idProcesso: item.id,
            acaoCaixa: 'ANALISE_SEM_TRAMITACAO'
          }
        })
        this.disabledAnalisar = false
      }
    },
    GERAR_CUSTAS: async (_this, { item }) => {
      _this.$router.push({
        name: 'analise/emissao-custas',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    RETORNAR_SETOR (_this, { item }) {
      this.retornarSetor({idProcesso: item.id})
        .then(() => {
          _this.refresh()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Processo retornado ao setor anterior')
        }).catch(({ message }) => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            message)
        })
    },
    EDITAR_ORDEM_SERVICO (_this, { item }) {
      this.$router.push({
        name: 'listagem-ordem-servico',
        params: {
          numero: item.numero
        }
      })
    },
    EXCLUIR_ORDEM_SERVICO (_this, { item }) {
      _this.$confirm('Tem certeza que deseja remover este item?', 'Atenção!', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(async () => {
        await _this.deleteOrdemServicoPorId(item.id)
        await _this.init()
      })
    },
    RESPONDER_INFORMACOES (_this, { item }) {
      this.$router.push({
        name: 'informacoes',
        params: {
          idSolicitacao: item.id
        }
      })
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    async EMITIR_DAE (_this, { item }) {
      this.$router.push({
        name: 'financeiro/dae/CadastroDae',
        params: {
          idProcesso: item.id
        }
      })
    },
    async EMITIR (_this, { item }) {
      await this.executarTramitacao(item.id)
      this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          urlOrigem: 'CAIXA_ENTRADA'
        }
      })
    },
    async EMITIR_EXTRATO_SENTENCA (_this, { item }) {
      await this.executarTramitacao(item.id)
      this.$router.push({
        name: 'continuar-emissao-extrato-sentenca',
        params: {
          idProcesso: item.id,
          urlOrigem: 'CAIXA_ENTRADA'
        }
      })
    },
    VISUALIZAR_COM_MODAL: (context) => {
      this.showModalResponsavel = true
    },
    GERENCIAR_PROCESSO: () => {
      return 'Gerenciar processo'
    },
    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    ASSINAR_TITULOS () {
      this.showModalAssinatura = true
    },
    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },
    AVOCAR_PROCESSO (_this, { item }) {
      this.idsProcessos.push(item.id)
      this.showModalAvocar = true
    },
    SOLICITAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.solicitarRetificacao = true
    },
    VALIDAR: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/validar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'VALIDACAO'
        }
      })
    },
    CALCULAR_VTN_AP: async (_this, { item }) => {
      const processo = await _this.getProcessoByProtocolo(item.numeroProtocolo)
      const municipioId = 1600105 || processo.dadosCadastro.dados.cadastro.imovel.municipio.id
      await _this.getPvtnAtivo(municipioId)
      await _this.executarTramitacao(item.id)
      _this.$router.push({
        name: 'calcular-vtn-ap',
        params: {
          processo: item,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    CALCULAR_VTN_MA: async (_this, { item }) => {
      await _this.executarTramitacaoByPerfil(item.id)
      _this.$router.push({
        name: 'calcular-vtn-ma',
        params: {
          idProcesso: item.id,
          protocolo: item.numeroProtocolo
        }
      })
    },
    CALCULAR_VTN_RR: async (_this, { item }) => {
      await _this.executarTramitacao(item.id)
      _this.$router.push({
        name: 'calcular-vtn-rr',
        params: {
          processo: item,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    async CONFERIR_TITULO (_this, { item }) {
      if (this.isEstadoMA) {
        await _this.executarTramitacao(item.id)
      }
      this.$router.push({
        name: 'conferencia-titulo-certidao',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },
    ACUSAR_ENTREGA: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/acusarEntrega',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ACUSAR_ENTREGA'
        }
      })
    },
    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }

      this.filtroRapido = novoFiltro
    },
    VALIDACAO_MANUAL (_this, { item }) {
      this.iniciarValidaoManual(item.id)
        .then(() => {
          _this.refresh()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Validação manual iniciada')

          _this.$router.push({
            name: 'analise/analisar',
            params: {
              idProcesso: item.id,
              acaoCaixa: 'ANALISE',
              analiseManual: true
            }
          })
        }).catch(({ message }) => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            message)
        })
    },
    async RETIFICAR_TITULO (_this, { item }) {
      await this.executarTramitacao(item.id)
      this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          idProcesso: item.id,
          tipo: 'RETIFICAR_TITULO',
          urlOrigem: 'CAIXA_ENTRADA'
        }
      })
    },
    REGERAR_PROCESSOS () {
      if (this.idsProcessos.length > 0) {
        this.confirmBox(this.$messages.AVISO_REGERAR, this.$messages.TITULO_WARNING,
          async () => {
            await this.regerar(this.idsProcessos)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) enviados para a Fila')
            location.reload()
          },
          () => { }
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.padding-left {
  padding-left: 25px;
}

@media (max-width: 780px) {
  .card-container {
    margin: 0 0 15px 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEntradaListagemUc.vue